import {Injectable} from "@angular/core";

@Injectable()
export class NumberUtils {

  /**
   * Format a number object with one decimal digit.
   * @param number
   */
  public static format1(number: number, totDecimalDigits: number): string {
    return number.toFixed(totDecimalDigits);
  }

}
